import React, { useState, useEffect } from "react";
import LeftNav from "../common/leftnav";
import { useUser } from "../../context/UserContext";
import SetupModal from "./setup_modal/setup_modal";
import GuidedSetupDetails from "./guided_setup_details_modal/guided_setup_details";
const GuidedSetupHomePage = () => {
  const { user } = useUser();
  const [showModal, setShowModal] = useState(false);
  const [showSetupModal, setShowSetupModal] = useState(true);
  const [showGuidedSetupDetails, setShowGuidedSetupDetails] = useState(false);
  useEffect(() => {
    if (user?.isSetupComplete) {
      setShowSetupModal(false);
    } else {
      setShowModal(true);
    }
  }, [user]);

  const handleCloseModal = () => setShowModal(false);
  const handleSetupClick = () => {
    setShowSetupModal(false);
    setShowGuidedSetupDetails(true);
  };
  return (
    <div className="d-flex">
      <LeftNav />
      <div className="dashboard-content flex-grow-1 p-4 bg-light">
        {showSetupModal && (
          <SetupModal
            show={showModal}
            handleClose={handleCloseModal}
            onSetupClick={handleSetupClick}
          />
        )}
        {showGuidedSetupDetails && <GuidedSetupDetails show={showGuidedSetupDetails}/>}
      </div>
    </div>
  );
};

export default GuidedSetupHomePage;
